import { render, staticRenderFns } from "./Poly_Vertices.vue?vue&type=template&id=350ec961"
import script from "./Poly_Vertices.vue?vue&type=script&lang=js"
export * from "./Poly_Vertices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports